import translations from './translations'

translations.add('en', {
    yourKlarnaPaymentUnsuccessful: 'Your Klarna payment was unsuccessful. Please try again later'
})
